import React, { useMemo } from 'react'
import { createPortal } from 'react-dom'

import styles from './financeOnboarding.module.scss'

const BURST_COUNT = 50
const RAIN_COUNT = 90

const rand = (min, max) => min + Math.random() * (max - min)

// Confetti perayaan murni CSS (tanpa library): letupan dari tengah layar lalu hujan dari
// atas. Posisi & arah acak dihitung sekali saat mount, animasi berjalan sekali.
const Confetti = () => {
  const burst = useMemo(
    () =>
      Array.from({ length: BURST_COUNT }, () => {
        const angle = rand(0, Math.PI * 2)
        const dist = rand(120, 420)
        return {
          '--dx': `${Math.cos(angle) * dist}px`,
          '--dy': `${Math.sin(angle) * dist - 120}px`,
          '--r': `${rand(360, 1080)}deg`,
          '--d': `${rand(1.6, 2.6)}s`,
          '--delay': `${rand(0, 0.15)}s`,
        }
      }),
    [],
  )

  const rain = useMemo(
    () =>
      Array.from({ length: RAIN_COUNT }, () => ({
        left: `${rand(0, 100)}%`,
        '--sway': `${rand(-80, 80)}px`,
        '--r': `${rand(360, 1440)}deg`,
        '--d': `${rand(2.8, 4.6)}s`,
        '--delay': `${rand(0.2, 1.8)}s`,
      })),
    [],
  )

  return createPortal(
    <div className={styles.confetti} aria-hidden="true">
      {burst.map((style, i) => (
        // eslint-disable-next-line react/no-array-index-key -- daftar statis, tidak diurutkan ulang
        <i key={`b${i}`} className={styles.confettiBurst} style={style} />
      ))}
      {rain.map((style, i) => (
        // eslint-disable-next-line react/no-array-index-key -- daftar statis, tidak diurutkan ulang
        <i key={`r${i}`} className={styles.confettiRain} style={style} />
      ))}
    </div>,
    document.body,
  )
}

export default Confetti
